module.exports = {
  title: 'This Design',
  description: 'This is a thoughtful design studio forged in friendship.',
  url: 'https://this.design',
}
